// Module
var code = "<template> <require from=\"app/core/components/summary/job/staged-records-summary\"></require> <staged-records-summary system-code.bind=\"systemCode\" staged-job-id.bind=\"stagedJobId\" tenant-key.bind=\"tenantKey\" table-name.bind=\"tableName\" table-filter.bind=\"tableFilter\"></staged-records-summary> </template> ";
// Exports
module.exports = code;